(function () {
  // Sections start hidden (see .js-scroll-reveal in base.css) so they can ease in.
  // If anything in here fails, remove that class so the page is never left blank —
  // and only set __scrollRevealReady once setup has actually succeeded, so the
  // failsafe in theme.liquid still fires on a runtime error partway through.
  function revealEverything() {
    document.documentElement.classList.remove('js-scroll-reveal');
  }

  try {
    const sections = document.querySelectorAll('#MainContent .shopify-section');

    if (!sections.length) {
      revealEverything();
      return;
    }

    sections.forEach((section) => {
      const items = section.querySelectorAll(
        '.product-card, [class*="reviews-grid__card-"], [class*="reviews-grid__character-"]'
      );
      items.forEach((item, index) => {
        item.style.setProperty('--reveal-delay', `${Math.min(index, 6) * 80}ms`);
      });
    });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('scroll-reveal--visible'));
      window.__scrollRevealReady = true;
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
    window.__scrollRevealReady = true;
  } catch (error) {
    revealEverything();
  }
})();
